import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {MvsCrudService} from 'features/core/shared/service/crud/mvs-crud.service';

/**
 * AI:
 * Status: 'in progress'
 * Type: Service
 * SubType: MvsCrudService
 * Reason: Entity service of `bm.BillingRunMessage` - the RUN-LEVEL log message of a billing run
 *   (`messageType` = REGULAR / SEPA_FILE_GENERATION / SEPA_PRE_CHECK, `severity`, `message`,
 *   `detailedMessage`). Generic controller `/mvsa/bm/billingRunMessages`, no custom endpoints.
 *
 *   Why a service file exists although the entity is plain CRUD (fe_core_mvs-crud-service decision
 *   table, row "getObjectIcon() / getObjectLabels()"): round 11 (WP-A, FD-R11-5) makes the run
 *   messages visible on the run dashboard's „Meldungen" tab as a WidgetFactory table whose rows open
 *   the generic object dialog; that dialog derives its icon and title from these two overrides.
 *   No `getObjectComponent()` override - the generic read rendering is the intended one (the message
 *   is run output, never edited in the frontend).
 *
 *   The list is read by QL only (the dashboard widget and the `runMessages` count pipe of
 *   `bm-billing-run-tab-count-ql.service.ts`), never through `list()` here.
 */
@Injectable({providedIn: 'root'})
export class BillingRunMessageService extends MvsCrudService {

    constructor(protected override http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/bm/billingRunMessages');
    }

    override getObjectIcon(): string {
        return 'fa-solid fa-clipboard-list';
    }

    /** The German message text IS the title of the object - there is no separate name column. */
    override getObjectLabels(): string[] {
        return ['message'];
    }
}
